import { useState, useEffect } from 'react';
import { useApi } from './useApi';

export const useDashboardStats = () => {
  const { get } = useApi();
  const [stats, setStats] = useState({
    todayAppointments: 0,
    waitlistCount: 0,
    checkInsToday: 0,
    pendingReminders: 0,
    upcomingArrivals: [],
    recentCheckIns: []
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchStats = async () => {
    try {
      setLoading(true);
      const response = await get('/dashboard/stats/receptionist');
      if (response.data?.status === 'success') {
        setStats(response.data.data);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
    const interval = setInterval(fetchStats, 30000);
    return () => clearInterval(interval);
  }, []);

  return { stats, loading, error, refetch: fetchStats };
};